(function () {
  'use strict';

  angular
    .module('localization')
    .config(config);

  function config($translateProvider) {

    var data = {
      paymentTemplates: {
        "payingFrom": "Uplata sa:",
        "payingTo": "Uplata na:",
        "howMuch": "Iznos",
        "description": "Opis",
        "when": "Datum",
        "fullPaymentForm": "Prikaži cijeli obrazac za plaćanje",
        "showFullPaymentForm": "Prikaži cijeli obrazac za plaćanje",
        "pay": "Plati",
        "delete": "Obriši",
        "save": "Snimi",
        "signPayment": "Potpiši",
        "cancel": "Odustani",
        "status": "Status",
        "bankName": "Naziv banke",
        "bankAddress": "Adresa banke",
        "dueDate": "Datum dospjeća",
        "fromAccount": "Račun pošiljatelja",
        "toAccount": "Račun primatelja",
        "receiver": "Primalac",
        "receiverAddress": "Adresa primatelja",
        "amount": "Iznos",
        "signMsg": "Provjerite unesene podatke i potpišite",
        "saveTemplate": "Novi šablon",
        "invalidDate": "Datum je nevalidan!",
        "descriptionError": "Opis je obavezan!",
        "templateName": "Naziv šablona",
        "templateIcon": "Slika šablona",
        "deleteSuccess1": "Šablon",
        "deleteSuccess2": "je uspješno izbrisan."
      },
      templatesList: {
        "header":"Lista mojih šablona",
        "searchTemplates": "Pretraži šablone",
        "addNewTemplate": "+ Dodaj novi predložak",
        "listOfTemplates":"Lista šablona",
        "fromAccount":"S računa",
        "amount":"Iznos",
        "toPayee":"Primalac",
        "accountNumber":"Broj računa",
        "payeeStreet":"Adresa primatelja",
        "payeeCity":"Grad primatelja",
        "purposeCode":"Šifra namjene",
        "referenceModel":"Model",
        "referenceNumber":"Referentni broj",
        "addTemplateToFavorites":"Dodaj šablon u favorite",
        "edit":"Izmijeni",
        "save": "Snimi",
        "cancel": "Odustani"
      }
    };

    $translateProvider
      .translations('mne', data);
  }
}());
